import { render } from "./CrearProspectoModal.vue?vue&type=template&id=15d3ca16"
import script from "./CrearProspectoModal.vue?vue&type=script&lang=js"
export * from "./CrearProspectoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__